import { useQuery } from '@tanstack/react-query'
import epsClient from 'enrollment-platform/api/eps.client'
import { useSelector } from 'react-redux'
import { selectors } from 'store/modules/user-session'

import { OpenEnrollmentCustomerConfigs } from '../../domain'
import { parseOpenEnrollmentCustomerConfigs } from '../utils/parse-open-enrollment-customer-configs'

type UseCustomerConfigurationReturn = {
  customerConfigs: OpenEnrollmentCustomerConfigs
  isLoading: boolean
  isError: boolean
}

export const useCustomerConfiguration = ({
  enabled = true,
}: { enabled?: boolean } = {}): UseCustomerConfigurationReturn => {
  const currentCompanyId = useSelector(selectors.getCurrentCompanyId)
  const { data, isLoading, isError } = useQuery({
    queryKey: ['abp-open-enrollment-customer-configuration', currentCompanyId],
    queryFn: async () => {
      const response = await epsClient.get<Record<string, unknown>>(
        `/customers/${currentCompanyId}/configuration/toggles`
      )
      return response.data
    },
    enabled: enabled && Boolean(currentCompanyId),
  })

  const customerConfigs = parseOpenEnrollmentCustomerConfigs(data ?? {})

  return {
    customerConfigs,
    isLoading,
    isError,
  }
}
